<template>
  <f7-page>
    <navbar>
      <template
        v-slot:nav-title
        class="breadcrumbs"
      >
        <span
          class="breadcrumb-link"
          @click="$f7.views.main.router.navigate('/cockpit/', { reloadCurrent: true })"
        >
          {{ $t('Home_navbar_title') }}
        </span>
        <f7-icon class="icon-breadcrumb" />
        <span class="breadcrumb-title">{{ $t('LeftPanel_title_result') }}</span>
      </template>
    </navbar>
    <div class="content-devx transparent home-grid">
      <a href="/infoIrrigation/">
        <div class="dashboardItem">
          <img class="irrigation">
          <span class="textDashboardItem">Riego</span>
        </div>
      </a>
      <a href="/manureResult/detailManure/">
        <div class="dashboardItem">
          <div class="customDashboardItem">
            <img class="manure">
          </div>
          <span class="textDashboardItem">Abonado</span>
        </div>
      </a>
    </div>
    <div class="footer-note">
      <div class="content-note">
        <span class="note">
          Actualmente solo es posible obtener recomendaciones de fertirriego de todos los
          macronutrientes en tomate, pimiento, melón y pepino.
          En el resto de las especies están disponibles las recomendaciones de riego y de N.
        </span>
      </div>
    </div>
  </f7-page>
</template>

<script>
import navbar from '../../components/navbar/NavBar.vue';

export default {
  name: 'ResultsTabs',
  components: {
    navbar,
  },
  methods: {
  },
};
</script>
<style lang="scss" scoped>

@import "./result.scss";

</style>
